import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import Carousel, { Modal, ModalGateway } from 'react-images'

import { getEntity } from 'selectors/entitySelectors'
import { getImages } from 'selectors/inventorySelectors'
import { toggleQueryValue } from 'actions/pageStateActions'
import { isFramedIn } from 'selectors/appStatusSelectors'

import LesaVDP from 'components/widgets/LesaVDP'

import './Gallery.scss'

class Gallery extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = { currentImage: 1 }

    this.closeLightbox = () =>
      this.setState({
        currentImage: 1,
        lightboxIsOpen: false,
      })

    this.openLightbox = (idx = 1) =>
      this.setState({
        currentImage: idx,
        lightboxIsOpen: true,
      })

    window.openGallery = this.openLightbox.bind(this)
  }

  render() {
    let { images, shouldShowCustomerView, isFramedIn, vehicle } = this.props,
      { lightboxIsOpen, currentImage } = this.state

    return (
      <div
        id="vrp-gallery"
        className={c(
          'vrp-gallery',
          'vrp-section',
          `vrp-gallery-images-${images.length}`,
          {
            'vrp-gallery-few': images.length < 5,
            'vrp-gallery-manager': !shouldShowCustomerView || isFramedIn,
            'vrp-gallery-paymentiq': isFramedIn,
          },
        )}
      >
        <div className={c('vrp-gallery-inner')}>
          <LesaVDP vin={vehicle.vin} />
          {(images || []).map((image, i) => (
            <div
              key={i}
              className="vrp-gallery-img"
              style={{ background: `url(${image.src})` }}
              onClick={() => this.openLightbox(i)}
            />
          ))}
        </div>
        <ModalGateway>
          {lightboxIsOpen ? (
            <Modal onClose={this.closeLightbox}>
              <Carousel views={images} currentIndex={currentImage} />
            </Modal>
          ) : null}
        </ModalGateway>
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let id = op.id || op.vehicleId,
    vehicle = getEntity(state, id)

  return {
    ...op,
    id,
    vehicle,
    images: getImages(state, id),
    isFramedIn: isFramedIn(),
  }
}

export default connect(
  mapStateToProps,
  { toggleQueryValue },
)(Gallery)
